// src/components/chat/utils/messageHelpers.js
import React from 'react';
export const MAX_STORED_MESSAGES = 2;
export const MAX_STORED_MESSAGES_EVENT = 1;

export const limitMessages = (messageArray) => {
    if (!Array.isArray(messageArray)) return [];
    return messageArray.slice(-MAX_STORED_MESSAGES);
};

const limitMessagesEvent = (messageArray) => {
    if (!Array.isArray(messageArray)) return [];
    return messageArray.slice(-MAX_STORED_MESSAGES_EVENT);
};

export const renderMessages = (messages) => {
    if (!Array.isArray(messages)) return null;
    
    return messages.map((msg, index) => (
        <div 
            key={index} 
            className={`message ${msg.sender === 'user' ? 'user-message' : 'app-message'}`}
        >
            {msg.component ? (
                <div dangerouslySetInnerHTML={{ __html: msg.component }} />
            ) : (
                msg.text
            )}
        </div>
    ));
};

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return '';
};

export const saveMessagesToCookies = (messages) => {
    const limitedMessages = {
        daily: limitMessages(messages.daily),
        event: limitMessagesEvent(messages.event),
        combine: limitMessages(messages.combine)
    };
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (7 * 24 * 60 * 60 * 1000));
    document.cookie = `chatMessages=${JSON.stringify(limitedMessages)}; path=/; expires=${expirationDate.toUTCString()}`;
};

export const saveEmailToCookies = (email) => {
    if (email) {
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (7 * 24 * 60 * 60 * 1000));
        document.cookie = `user_email=${email}; path=/; expires=${expirationDate.toUTCString()}`;
    }
};